import { useCallback } from 'react'
import { BeforeSubmitHandler } from '../../../forms/TwinForm/types'
import { changeErrorMessage } from '../../reducers/reduxDispatch'
import useTwinTranslation from '../useTwinTranslation'

const useServiceCheckUnitPrice = () => {
    const { t } = useTwinTranslation()
    const ifUnitPriceMustHaveCurrency = t('ifUnitPriceMustHaveCurrency', 'Si introduces precio unitario debes poner obligatoriamente moneda')
    const ifCurrencyMustHaveUnitPrice = t('ifCurrencyMustHaveUnitPrice', 'Si introduces moneda debes poner obligatoriamente precio unitario')

    const checkUnitPriceAndCurrency: BeforeSubmitHandler = useCallback((vals) => {
        const unitPrice = vals['unitPrice']
        const CurrencyId = vals['CurrencyId']
        if (unitPrice && !CurrencyId) {
            changeErrorMessage(ifUnitPriceMustHaveCurrency)
            return false
        }
        if (!unitPrice && CurrencyId) {
            changeErrorMessage(ifCurrencyMustHaveUnitPrice)
            return false
        }
        return true
    }, [ifUnitPriceMustHaveCurrency, ifCurrencyMustHaveUnitPrice])
    
    return { checkUnitPriceAndCurrency }
}

export default useServiceCheckUnitPrice